import shellIdentity from '../utils/shellIdentity';

let fixTop = (e) => {
	var offset = e.offsetTop
	if (e.offsetParent != null) {
		offset += fixTop(e.offsetParent)
	}
	return offset
}

let fixLeft = (e) => {
	var offset = e.offsetLeft
	if (e.offsetParent != null) {
		offset += fixLeft(e.offsetParent)
	}
	return offset
}

let currentUserName = '';
let currentTip = '';

function notifyShellIdentity(options = {}) {
	const payload = {
		userName: currentUserName,
		tip: currentTip
	};
	if (options.tip !== undefined) {
		payload.tip = options.tip;
	}
	if (options.userName !== undefined) {
		payload.userName = options.userName;
	}
	if (typeof window !== 'undefined' && window.electronAPI) {
		if (typeof window.electronAPI.syncShellIdentity === 'function') {
			window.electronAPI.syncShellIdentity(payload);
		} else if (typeof window.electronAPI.sendEvent === 'function') {
			window.electronAPI.sendEvent('shell-identity:update', payload);
		}
	}
}

let setTitleTip = (tip, options = {}) => {
	const userName = typeof options.userName === 'string' ? options.userName : currentUserName;
	const nextTip = tip === undefined ? currentTip : String(tip || '');
	currentUserName = userName || '';
	currentTip = nextTip;
	const title = shellIdentity.buildShellTitle({
		userName: currentUserName,
		tip: currentTip,
		appName: options.appName
	});
	document.title = title;
	notifyShellIdentity({ userName: currentUserName, tip: currentTip });
}

export default {
	fixTop,
	fixLeft,
	setTitleTip
}
